import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router";
import { UncontrolledAlert } from 'reactstrap';

import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import { isIOS, isMobile } from 'react-device-detect';

import { COLLAPSED_DRAWER, FIXED_DRAWER } from 'constants/ActionTypes';
import ColorOption from 'containers/Customizer/ColorOption';
import asyncComponent from '../util/AsyncFunc';


import Dashboard from './dashboard'
import Team from './teamdetails'
import Template from './templatedetails'
import User from './userdetails'
import Customer from './customerdetails'
import Meeting from './meetingdetails'
import AgendaItem from './agendaitemdetails'
import DocumentDetails from './documentdetails'
import Resolution from './resolutiondetails'
import Assignee from './assigneedetails'
import Decision from './decisiondetails'
import Mail from './maildetails'
import Archive from './archivedetails'
import audit from './auditdetails'
import eSignature from './esignaturedetails'

//auth
import {
    userIsSuperAdminRedir
} from './auth'

import * as loadswitchercommittees from '../actions/teamdetails';
import * as toggleCollapsedNav from '../actions/Setting';

class App extends React.Component {
    onToggleCollapsedNav = (e) => {
        const val = !this.props.navCollapsed;
        this.props.actions.toggleCollapsedNav(val);
    };

    componentDidMount() {
        const teamDetails = this.props.teamDetails;
        // console.log('props', this.props)
        this.setState({ setValue: false, })
        if (!(teamDetails && teamDetails.switchteamdetailsList && teamDetails.switchteamdetailsList.length > 0))
            this.props.actions.loadswitchercommittees();
    }

    render() {
        const { match, drawerType, location, loginUser } = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

        // console.log('app Index:',this.props)
        // const DashboardProtected = userIsAuthenticatedRedir(Dashboard)
        const CustomerProtected = userIsSuperAdminRedir(Customer)
        // const UserProtected = userIsAuthenticatedRedir(User)
        // const TeamProtected = userIsAuthenticatedRedir(Team)

        //set default height and overflow for iOS mobile Safari 10+ support.
        if (isIOS && isMobile) {
            $('#body').addClass('ios-mobile-view-height')
        }
        else if ($('#body').hasClass('ios-mobile-view-height')) {
            $('#body').removeClass('ios-mobile-view-height')
        }
        return (
            <div className={`app-container ${drawerStyle}`}>
                {/* {// console.log(loginUser)} */}
                <Sidebar onToggleCollapsedNav={this.onToggleCollapsedNav.bind(this)} loginUser={this.props.loginUser} />
                <div className="app-main-container">
                    <div className="app-header">
                        <Header drawerType={drawerType} onToggleCollapsedNav={this.onToggleCollapsedNav} />
                    </div>
                    <main className="app-main-content-wrapper">
                        <div className="app-main-content">
                            <Route path={`${match.url}dashboard/:id?`} component={Dashboard} />
                            <Route path={`${match.url}customer`} component={CustomerProtected} />
                            <Route path={`${match.url}team`} component={Team} />
                            <Route path={`${match.url}template`} component={Template} />
                            <Route path={`${match.url}user`} component={User} />
                            <Route path={`${match.url}mail`} component={Mail} />
                            <Route path={`${match.url}meeting`} component={Meeting} />
                            <Route path={`${match.url}agenda`} component={AgendaItem} />
                            <Route path={`${match.url}document`} component={DocumentDetails} />
                            <Route path={`${match.url}resolution`} component={Resolution} />
                            <Route path={`${match.url}assignee`} component={Assignee} />
                            <Route path={`${match.url}decision`} component={Decision} />
                            <Route path={`${match.url}archive`} component={Archive} />
                            <Route path={`${match.url}audit`} component={audit} />
                            <Route path={`${match.url}esignature`} component={eSignature} />
                        </div>
                        <Footer />
                    </main>
                </div>
                <ColorOption />
            </div>
        );
    }
}


const mapStateToProps = ({ settings, loginUser, teamDetails }) => {
    const { navCollapsed, drawerType } = settings;
    return { navCollapsed, drawerType, loginUser, teamDetails }
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({...loadswitchercommittees, ...toggleCollapsedNav}, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./app/index.js